import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { LinearProgress, Grid } from '@material-ui/core';
const styles = makeStyles(theme => ({
    loader: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    alignItemsAndJustifyContent: {
        //width: 400,
        width: '20%',
        border: '1px solid #e1e1e1',
        color: '#888',
        height: 50,
        display: 'flex',
        marginTop: 10,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fafafa'
    },
}));
export const Loader = props => {
    const classes = styles();
    const items = [];
    let i = 0;
    items.push(React.createElement(LinearProgress, { className: classes.loader }));
    if (props.text) {
        items.push(React.createElement("div", { className: classes.alignItemsAndJustifyContent, key: "loaderText" + i++ }, props.text));
    }
    return (React.createElement(Grid, { container: true, spacing: 0, alignItems: "center", justify: "center" }, items));
};
